// category
const CATEGORY_LIST = '/category/all';

// trainers
const TRAINERS_LIST = '/teacher/all';

// allowed
const ALLOWED_LIST = '/userLevel/all';

// tags
const TAGS_LIST = '/tag/all';

// course
const CREATE_STEP_ONE = '/course/step1';
const UPDATE_STEP_ONE = '/course/update';
const CREATE_STEP_TWO = '/course/step2';
const UPDATE_STEP_TWO = '/course/update';
const CREATE_STEP = '/courseStep/create';
const UPDATE_STEP = '/courseStep/update';
const DELETE_STEP = '/courseStep/remove';
const CREATE_COURSE = '/course/final';
const UPDATE_COURSE = '/courseStep/index';
const DEACTIVE_COURSE = '/course/deactive';
const ACTIVE_COURSE = '/course/active';
const ARCHIEVE_COURSE = '/course/archive';

// media
const UPLOAD_MEDIA = '/media/upload';
const UPLOAD_MEDIA_MANULLY = '/media/uploadManually';

export {
  CATEGORY_LIST,
  TRAINERS_LIST,
  ALLOWED_LIST,
  TAGS_LIST,
  CREATE_STEP_ONE,
  UPDATE_STEP_ONE,
  CREATE_STEP_TWO,
  UPDATE_STEP_TWO,
  UPLOAD_MEDIA,
  CREATE_STEP,
  UPDATE_STEP,
  DELETE_STEP,
  CREATE_COURSE,
  UPDATE_COURSE,
  DEACTIVE_COURSE,
  ACTIVE_COURSE,
  ARCHIEVE_COURSE,
  UPLOAD_MEDIA_MANULLY,
};
